var _path, _path2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroup1116601110(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1641 18.1105C10.3099 18.4939 10.8523 18.4939 10.9994 18.1105L12.9086 13.132C12.9543 13.0128 13.0487 12.9188 13.168 12.8735L18.1602 10.9791C18.5449 10.8332 18.5458 10.2893 18.1616 10.1433L13.1756 8.24895C13.0564 8.20368 12.9624 8.10964 12.9171 7.99051L11.0242 3.01201C10.8784 2.62861 10.336 2.62861 10.1889 3.01201L8.27967 7.99051C8.23398 8.10964 8.13962 8.20368 8.02032 8.24895L3.02809 10.1433C2.6434 10.2893 2.64251 10.8332 3.02672 10.9791L8.01273 12.8735C8.13187 12.9188 8.22593 13.0128 8.27123 13.132L10.1641 18.1105Z",
    fill: "url(#paint0_linear_2749_5874)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0656 3.07958C16.029 2.91041 15.8027 2.87611 15.7172 3.02677L14.9657 4.34959C14.9391 4.39641 14.8938 4.42967 14.8412 4.44102L13.3524 4.76189C13.1826 4.79847 13.1479 5.02532 13.2989 5.11052L14.6241 5.85783C14.6709 5.88425 14.7042 5.92943 14.7156 5.982L15.0367 7.46737C15.0733 7.63654 15.2996 7.67084 15.3852 7.52017L16.1366 6.19736C16.1632 6.15054 16.2086 6.11728 16.2612 6.10593L17.75 5.78506C17.9197 5.74848 17.9545 5.52163 17.8034 5.43643L16.4783 4.68912C16.4314 4.6627 16.3981 4.61752 16.3868 4.56495L16.0656 3.07958Z",
    fill: "url(#paint1_linear_2749_5874)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.14105 14.2646C7.10448 14.0955 6.87818 14.0612 6.79259 14.2118L6.35236 14.9868C6.32576 15.0336 6.28045 15.0669 6.22781 15.0782L5.35625 15.2661C5.18652 15.3026 5.15176 15.5295 5.30283 15.6147L6.07858 16.0522C6.12542 16.0786 6.15872 16.1238 6.17009 16.1763L6.35823 17.0465C6.39481 17.2157 6.62111 17.25 6.7067 17.0993L7.14693 16.3244C7.17352 16.2776 7.21884 16.2443 7.27147 16.233L8.14304 16.0451C8.31277 16.0085 8.34753 15.7817 8.19646 15.6965L7.42071 15.259C7.37386 15.2326 7.34057 15.1874 7.3292 15.1348L7.14105 14.2646Z",
    fill: "url(#paint2_linear_2749_5874)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2749_5874",
    x1: 10.58,
    y1: 19.2041,
    x2: 10.58,
    y2: 1.9184,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E732A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#EFD09D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE8641"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2749_5874",
    x1: 15.9613,
    y1: 2.59702,
    x2: 15.1499,
    y2: 7.95126,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E732A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#EFD09D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE8641"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2749_5874",
    x1: 7.03672,
    y1: 13.7821,
    x2: 6.46872,
    y2: 17.53,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E732A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#EFD09D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE8641"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup1116601110);
export default __webpack_public_path__ + "static/media/Group 1116601110.b9c3506c221160dbc7bfcbfc54d330bd.svg";
export { ForwardRef as ReactComponent };